import React, { useState, useContext } from "react";
// import PropTypes from 'prop-types';
import { useWatch, useFormState } from "react-hook-form";

import { isMappableArray } from "../../../utils/helpers";
import SelectInputStyles from "./styles";
import IconChevron from "../../Svgs/icon-chevron";
import OutsideClick from "../../OutsideClick";
import AppContext from "../../../App/AppContext";

const SelectInput = ({
  register,
  fieldName,
  label,
  required,
  options,
  placeholder,
  formState: { errors = {} } = {},
  setValue,
  errorMessage,
  helperText,
  control,
  trigger,
}) => {
  const { options: { primary_color = "" } = {} } = useContext(AppContext);

  const currentValue = useWatch({
    control,
    name: fieldName,
  });
  const displayValue = options.find(
    (item) => item.value === currentValue
  )?.title;
  const [showOptions, setShowOptions] = useState(false);

  const handleClick = (option) => {
    const { value, title } = option;
    setValue(fieldName, value, { shouldValidate: true });
    setShowOptions(false);
  };

  // conditional classes:
  const conditionalClasses = `${errors[fieldName] ? "error" : ""} ${
    showOptions ? "focus" : ""
  } ${displayValue ? "hasValue" : ""}`;

  return (
    <SelectInputStyles
      className="select-input-container"
      $primary_color={primary_color}
    >
      <div className="label-container">
        <div>
          <label
            htmlFor={fieldName}
            dangerouslySetInnerHTML={{ __html: label }}
          />{" "}
          {required && <span className="required-asterisk">*</span>}
        </div>
        {helperText && <span className="helper-text">{helperText}</span>}
      </div>
      <OutsideClick onClick={() => setShowOptions(false)}>
        <div
          className="input__container"
          onClick={async () => {
            setShowOptions((prevInput) => !prevInput);
            // trigger validation
            const result = await trigger(fieldName);
          }}
        >
          <div className={`input__mock ${conditionalClasses}`}>
            {displayValue ? (
              <span>{displayValue}</span>
            ) : (
              <span className="input__mock--placeholder">{placeholder}</span>
            )}
          </div>
          <input
            id={fieldName}
            type="hidden"
            {...register(fieldName, {
              required,
            })}
          />
          <div className="input__arrow">
            <IconChevron fill="#a1a1a1" rotate={showOptions ? "180" : "0"} />
          </div>
        </div>
        {showOptions && (
          <div className="options__container">
            <div className="options">
              {isMappableArray(options) &&
                options.map((option) => {
                  return (
                    <div
                      key={option?.value}
                      className="options__item"
                      onClick={() => handleClick(option)}
                    >
                      {option?.title}
                    </div>
                  );
                })}
            </div>
          </div>
        )}
      </OutsideClick>
      {errors[fieldName] && <span className="input-error">{errorMessage}</span>}
    </SelectInputStyles>
  );
};
export default SelectInput;

// SelectInput.propTypes = {
//     register: PropTypes.func.isRequired,
//     fieldName: PropTypes.string.isRequired,
//     label: PropTypes.string.isRequired,
//     required: PropTypes.bool,
//     formState: PropTypes.object,
//     placeholder: PropTypes.string,
//     errorMessage: PropTypes.string,
//     setValue: PropTypes.func.isRequired,
//     control: PropTypes.object.isRequired,
//     options: PropTypes.arrayOf(
//         PropTypes.shape({
//             title: PropTypes.string.isRequired,
//             value: PropTypes.string.isRequired,
//         }),
//     ),
//     helperText: PropTypes.string,
// };
